export { default as UserDashboard } from './Dashboard';

export type {
	DashboardProps,
	DashboardLink,
	DashboardProfileItem,
	DashboardProfileItemIcon,
	DashboardProfileSection,
	DashboardEventItem,
	DashboardEventsSection,
	DashboardConsultingSection,
	DashboardShortcutSection,
	DashboardEmployeeAccessSection
} from './types';
